import type { TranslationTag } from '@ps/web-core-intl';

import type { OnboardingInfo } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';

import {
  TXTWCL_DepositX_withdrawX_transaction_ELL,
  TXTWCL_This_is_where_you_can_view_and_ELL,
  TXTWCL_View_your_available_balance_an_ELL
} from './cashierOnboardingStepsInfo.messages.json';

export const cashierOnboardingSteps = (isMobile = false): OnboardingInfo<TranslationTag>[] => [
  {
    id: 'tour-cash-1',
    context: TXTWCL_View_your_available_balance_an_ELL,
    placement: isMobile ? 'bottom' : 'right'
  },
  {
    id: 'tour-cash-2',
    context: TXTWCL_This_is_where_you_can_view_and_ELL,
    placement: isMobile ? 'top' : 'right'
  },
  {
    id: 'tour-cash-3',
    context: TXTWCL_DepositX_withdrawX_transaction_ELL,
    placement: isMobile ? 'top' : 'left'
  }
];

export enum CashierOnboardingStep {
  StepSummaryPanel,
  StepLimitPanel,
  StepCashierPanel
}

export enum CashierLocalSettingsPath {
  Cashier = 'cashier.cashierTour'
}
